import { createSelector } from "reselect";
import { isValid } from "date-fns";
import { getMerchPreviewStartDate } from "app/pages/Merchandising/merchandisingSelector";
import { formatPreviewDateToUTCDate, isBetweenDates } from "app/utils/utils";
import { getPartnerCode } from "app/reducers/partnerSelector";

export const getPushNotifs = state =>
	state.pushNotification && state.pushNotification.pushNotifications;

const isPushNotificationExpired = (pushNotification, previewDateTimestamp) => {
	const todayTimestamp = new Date().getTime();
	const pushNotificationEndAtTimestamp = new Date(pushNotification.endAt).getTime();
	const pushNotificationStartAtTimestamp = new Date(pushNotification.launchAt).getTime();
	if (isValid(previewDateTimestamp)) {
		return !(
			previewDateTimestamp >= pushNotificationEndAtTimestamp ||
			previewDateTimestamp < pushNotificationStartAtTimestamp
		);
	}

	// do not return expired push notification
	return pushNotificationEndAtTimestamp >= todayTimestamp;
};

export const getPushNotifications = createSelector(
	[getPushNotifs, getPartnerCode, getMerchPreviewStartDate],
	(pushNotifications = [], partnerCode, previewStartDate) => {
		// Déterminer la date de référence à utiliser (prévisualisation ou date actuelle)
		const referenceDate = previewStartDate
			? formatPreviewDateToUTCDate(previewStartDate)
			: new Date();

		const filteredByPartner = partnerCode
			? pushNotifications.filter(notification => {
					const codes = notification?.marketingCodes ?? [];
					return codes.length === 0 || codes.some(mkt => mkt?.code === partnerCode);
				})
			: pushNotifications;

		// Appliquer la fonction de filtrage appropriée selon la présence d'une date de prévisualisation
		return filteredByPartner.filter(notification =>
			previewStartDate
				? isPushNotificationExpired(notification, referenceDate)
				: isBetweenDates(notification.launchAt, notification.endAt)
		);
	}
);
